import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import AOS from "aos";
import "aos/dist/aos.css";

import WhiteNavbar from "components/Navbars/WhiteNavbar";
import Footer from "components/Footers/Footer";

import { Container, Modal, ModalBody } from "reactstrap";
import { IoIosArrowBack, IoIosArrowForward, IoIosClose } from "react-icons/io";

import "../assets/css/Galerimiz.css";

// 1.jpeg - 19.jpeg (ELLE IMPORT)
import g1 from "../assets/eksiogluPictures/galerimiz/1.jpeg";
import g2 from "../assets/eksiogluPictures/galerimiz/2.jpeg";
import g3 from "../assets/eksiogluPictures/galerimiz/3.jpeg";
import g4 from "../assets/eksiogluPictures/galerimiz/4.jpeg";
import g5 from "../assets/eksiogluPictures/galerimiz/5.jpeg";
import g6 from "../assets/eksiogluPictures/galerimiz/6.jpeg";
import g7 from "../assets/eksiogluPictures/galerimiz/7.jpeg";
import g8 from "../assets/eksiogluPictures/galerimiz/8.jpeg";
import g9 from "../assets/eksiogluPictures/galerimiz/9.jpeg";
import g10 from "../assets/eksiogluPictures/galerimiz/10.jpeg";
import g11 from "../assets/eksiogluPictures/galerimiz/11.jpeg";
import g12 from "../assets/eksiogluPictures/galerimiz/12.jpeg";
import g13 from "../assets/eksiogluPictures/galerimiz/13.jpeg";
import g14 from "../assets/eksiogluPictures/galerimiz/14.jpeg";
import g15 from "../assets/eksiogluPictures/galerimiz/15.jpeg";
import g16 from "../assets/eksiogluPictures/galerimiz/16.jpeg";
import g17 from "../assets/eksiogluPictures/galerimiz/17.jpeg";
import g18 from "../assets/eksiogluPictures/galerimiz/18.jpeg";
import g19 from "../assets/eksiogluPictures/galerimiz/19.jpeg";

const HERO_AUTOPLAY_MS = 4500;

const Galerimiz = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // ÜST SLIDER bağımsız state
  const [heroIndex, setHeroIndex] = useState(0);
  const [heroAnimKey, setHeroAnimKey] = useState(0);
  const [isHeroPaused, setIsHeroPaused] = useState(false);

  // LIGHTBOX bağımsız state (thumb veya hero’dan açılır, hero’yu etkilemez)
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const images = useMemo(
    () => [
      { id: "g-1", src: g1, alt: "Ekşioğlu Hukuk - Galeri Görseli 1" },
      { id: "g-2", src: g2, alt: "Ekşioğlu Hukuk - Galeri Görseli 2" },
      { id: "g-3", src: g3, alt: "Ekşioğlu Hukuk - Galeri Görseli 3" },
      { id: "g-4", src: g4, alt: "Ekşioğlu Hukuk - Galeri Görseli 4" },
      { id: "g-5", src: g5, alt: "Ekşioğlu Hukuk - Galeri Görseli 5" },
      { id: "g-6", src: g6, alt: "Ekşioğlu Hukuk - Galeri Görseli 6" },
      { id: "g-7", src: g7, alt: "Ekşioğlu Hukuk - Galeri Görseli 7" },
      { id: "g-8", src: g8, alt: "Ekşioğlu Hukuk - Galeri Görseli 8" },
      { id: "g-9", src: g9, alt: "Ekşioğlu Hukuk - Galeri Görseli 9" },
      { id: "g-10", src: g10, alt: "Ekşioğlu Hukuk - Galeri Görseli 10" },
      { id: "g-11", src: g11, alt: "Ekşioğlu Hukuk - Galeri Görseli 11" },
      { id: "g-12", src: g12, alt: "Ekşioğlu Hukuk - Galeri Görseli 12" },
      { id: "g-13", src: g13, alt: "Ekşioğlu Hukuk - Galeri Görseli 13" },
      { id: "g-14", src: g14, alt: "Ekşioğlu Hukuk - Galeri Görseli 14" },
      { id: "g-15", src: g15, alt: "Ekşioğlu Hukuk - Galeri Görseli 15" },
      { id: "g-16", src: g16, alt: "Ekşioğlu Hukuk - Galeri Görseli 16" },
      { id: "g-17", src: g17, alt: "Ekşioğlu Hukuk - Galeri Görseli 17" },
      { id: "g-18", src: g18, alt: "Ekşioğlu Hukuk - Galeri Görseli 18" },
      { id: "g-19", src: g19, alt: "Ekşioğlu Hukuk - Galeri Görseli 19" },
    ],
    [],
  );

  const hasImages = images.length > 0;

  const clamp = useCallback(
    (idx) => Math.max(0, Math.min(idx, images.length - 1)),
    [images.length],
  );

  const getLoopedIndex = useCallback(
    (idx) => {
      if (!images.length) return 0;
      return (idx + images.length) % images.length;
    },
    [images.length],
  );

  // ===== ÜST SLIDER (Hero) fonksiyonları =====
  const heroGoTo = useCallback(
    (idx) => {
      const nextIdx = getLoopedIndex(idx);
      setHeroIndex(nextIdx);
      setHeroAnimKey((k) => k + 1);
    },
    [getLoopedIndex],
  );

  const heroNext = useCallback(
    () => heroGoTo(heroIndex + 1),
    [heroIndex, heroGoTo],
  );
  const heroPrev = useCallback(
    () => heroGoTo(heroIndex - 1),
    [heroIndex, heroGoTo],
  );

  const heroActive = hasImages ? images[heroIndex] : null;

  // ===== Lightbox fonksiyonları (Hero’dan bağımsız) =====
  const openHeroLightbox = useCallback(() => {
    if (!hasImages) return;
    setLightboxIndex(heroIndex); // hero hangi slayttaysa oradan aç
    setLightboxOpen(true);
  }, [hasImages, heroIndex]);

  const closeLightbox = useCallback(() => setLightboxOpen(false), []);

  const lightboxGoTo = useCallback(
    (idx) => setLightboxIndex(clamp(idx)),
    [clamp],
  );

  const lightboxNext = useCallback(
    () => lightboxGoTo(lightboxIndex + 1),
    [lightboxIndex, lightboxGoTo],
  );

  const lightboxPrev = useCallback(
    () => lightboxGoTo(lightboxIndex - 1),
    [lightboxIndex, lightboxGoTo],
  );

  const lightboxActive = hasImages ? images[lightboxIndex] : null;

  // ===== Genel effectler =====
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    return () => {
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  useEffect(() => {
    AOS.init({ once: true, duration: 600, easing: "ease-out" });
  }, []);

  useEffect(() => {
    if (!hasImages || images.length < 2 || lightboxOpen || isHeroPaused) return;

    const intervalId = window.setInterval(() => {
      setHeroIndex((currentIndex) => getLoopedIndex(currentIndex + 1));
      setHeroAnimKey((currentKey) => currentKey + 1);
    }, HERO_AUTOPLAY_MS);

    return () => window.clearInterval(intervalId);
  }, [getLoopedIndex, hasImages, images.length, isHeroPaused, lightboxOpen]);

  // Lightbox açıkken klavye kontrolü
  useEffect(() => {
    const onKeyDown = (e) => {
      if (!lightboxOpen) return;
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowRight") lightboxNext();
      if (e.key === "ArrowLeft") lightboxPrev();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [lightboxOpen, closeLightbox, lightboxNext, lightboxPrev]);

  return (
    <>
      <Helmet>
        <title>Galerimiz | Ekşioğlu Hukuk</title>
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="Ekşioğlu Hukuk Ofisi galerisi: ofisimizden ve çalışma ortamımızdan modern kareler."
          data-rh="true"
        />
        <link
          rel="canonical"
          href="https://www.eksiogluhukukofisi.com/galerimiz"
        />
        <meta property="og:title" content="Galerimiz | Ekşioğlu Hukuk" />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content="Ekşioğlu Hukuk Ofisi galerisi: ofisimizden ve çalışma ortamımızdan kareler."
        />
        <meta
          property="og:image"
          content="https://www.eksiogluhukukofisi.com/static/media/eksiogluWhiteLogo.e14b5e9c41e5271d670c.png"
        />
        <meta
          property="og:url"
          content="https://www.eksiogluhukukofisi.com/galerimiz"
        />
      </Helmet>

      <WhiteNavbar />
      <div className="mt-[75px]" />

      <section className="w-full bg-white px-4 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-8 md:py-12 font-sans">
        <Container>
          {/* Header */}
          <div className="w-full max-w-6xl mx-auto" data-aos="fade-up">
            <div className="flex items-center mb-4">
              <div className="flex-1 h-1 bg-[#CA9457] rounded-full" />
              <h1 className="mx-4 text-2xl md:text-4xl font-extrabold text-slate-900 leading-tight text-center">
                Galerimiz
              </h1>
              <div className="flex-1 h-1 bg-[#CA9457] rounded-full" />
            </div>

            <p className="text-gray-700 text-base md:text-lg leading-8 text-center max-w-3xl mx-auto">
              Ofisimizden ve çalışma ortamımızdan seçilmiş kareler.
            </p>
          </div>

          {/* HERO SLIDER */}
          <div className="w-full max-w-6xl mx-auto mt-8" data-aos="fade-up">
            {!hasImages ? (
              <div className="rounded-xl border border-slate-200 bg-slate-50 p-6 text-center text-slate-700">
                <div className="font-bold text-lg">Görsel bulunamadı.</div>
              </div>
            ) : (
              <>
                  <div
                    className="galeri-hero"
                    aria-label="Galerimiz slider"
                    onMouseEnter={() => setIsHeroPaused(true)}
                    onMouseLeave={() => setIsHeroPaused(false)}
                  >
                  <button
                    type="button"
                    className="galeri-hero-btn left"
                    aria-label="Önceki"
                    onClick={heroPrev}
                  >
                    <IoIosArrowBack size={22} />
                  </button>

                  <button
                    type="button"
                    className="galeri-hero-btn right"
                    aria-label="Sonraki"
                    onClick={heroNext}
                  >
                    <IoIosArrowForward size={22} />
                  </button>

                  {/* ÜST GÖRSELE TIKLAYINCA LIGHTBOX AÇ (hero’dan) */}
                    <button
                      type="button"
                      className="galeri-hero-media"
                      onClick={openHeroLightbox}
                      aria-label="Görseli büyüt"
                  >
                    <div className="galeri-hero-frame">
                      <img
                        key={`${heroActive?.id}-${heroAnimKey}`}
                        src={heroActive?.src}
                        alt={heroActive?.alt}
                        className="galeri-hero-img"
                        loading="eager"
                      />
                      <div className="galeri-hero-grad" aria-hidden="true" />
                      {/* İSİM / YAZI YOK ✅ */}
                    </div>
                  </button>
                </div>

                {/* Dots (hero slider’a bağlı) */}
                <div className="galeri-dots" aria-label="Slider noktaları">
                  {images.map((_, i) => (
                    <button
                      key={i}
                      type="button"
                      aria-label={`Slayt ${i + 1}`}
                      onClick={() => heroGoTo(i)}
                      className={`galeri-dot ${i === heroIndex ? "is-active" : ""}`}
                    />
                  ))}
                </div>

                {/* Thumbnails: tıklayınca ana görsel değişir */}
                <div className="galeri-thumbs-grid">
                  {images.map((img, idx) => (
                    <button
                      key={img.id}
                      type="button"
                      className={`galeri-thumb ${heroIndex === idx ? "is-selected" : ""}`}
                      onClick={() => heroGoTo(idx)}
                      aria-label="Ana görseli değiştir"
                      title="Ana görseli değiştir"
                    >
                      <img
                        src={img.src}
                        alt={img.alt}
                        className="galeri-thumb-img"
                        loading="lazy"
                      />
                    </button>
                  ))}
                </div>
              </>
            )}
          </div>
        </Container>
      </section>

      {/* LIGHTBOX sadece ana görselden açılır */}
      <Modal
        isOpen={lightboxOpen}
        toggle={closeLightbox}
        size="xl"
        centered
        backdrop
        fade
        className="galeri-modal"
        contentClassName="galeri-modal-content"
      >
        <ModalBody className="p-0">
          <div className="galeri-lightbox">
            <button
              type="button"
              aria-label="Kapat"
              onClick={closeLightbox}
              className="galeri-lightbox-close"
            >
              <IoIosClose size={34} />
            </button>

            <button
              type="button"
              aria-label="Önceki görsel"
              onClick={lightboxPrev}
              className="galeri-lightbox-nav left"
            >
              <IoIosArrowBack size={22} />
            </button>

            <button
              type="button"
              aria-label="Sonraki görsel"
              onClick={lightboxNext}
              className="galeri-lightbox-nav right"
            >
              <IoIosArrowForward size={22} />
            </button>

            <div className="galeri-lightbox-media">
              {lightboxActive ? (
                <img
                  src={lightboxActive.src}
                  alt={lightboxActive.alt}
                  className="galeri-lightbox-img"
                />
              ) : null}
            </div>

            {/* İSİM / YAZI YOK ✅ */}
          </div>
        </ModalBody>
      </Modal>

      <Footer />
    </>
  );
};

export default Galerimiz;
